import DomainEntity from '@/models/DomainEntity'

export default class StrategyContracts extends DomainEntity {
  static get collectionName() {
    return 'strategycontracts/'
  }

  static get parentKey() {
    return 'strategy'
  }

  static defaults() {
    return {
      add: [],
      update: {},
      cancel: [],
    }
  }
}
